interface SimpleRewriteOptions {
	keepEnInPath?: boolean;
	requestUrl?: string;
	forceAddPP?: boolean;
	skipPathShortening?: boolean;
}

const PP_URL_SLUG = 'preferredpartner';
const BL_MODE_AUTHOR = 'author';

const getClientEnv = (): Record<string, unknown> | undefined => {
	if (typeof globalThis === 'undefined' || !('window' in globalThis)) {
		return undefined;
	}
	return (globalThis as typeof globalThis & { window?: { CLIENT_ENV?: Record<string, unknown> } })
		.window?.CLIENT_ENV;
};

const isAuthorMode = (options: SimpleRewriteOptions): boolean => {
	if (options.skipPathShortening) {
		return true;
	}
	return getClientEnv()?.['FSHR_PUBLIC_BL_MODE'] === BL_MODE_AUTHOR;
};

const applyPreferredPartnerSlug = (path: string, options: SimpleRewriteOptions): string => {
	if (
		(options.requestUrl?.includes(`/${PP_URL_SLUG}`) || options.requestUrl?.includes('.pp')) && //also check for pp selector
		(path.includes('/content/fshr/pages') || options.forceAddPP) &&
		!path.includes(`/${PP_URL_SLUG}`)
	) {
		const pathParts = path.split('/');
		const pagesIndex = pathParts.indexOf('pages');
		const languageIndex = pagesIndex === -1 && path.startsWith('http') ? 2 : pagesIndex + 1;
		pathParts.splice(languageIndex + 1, 0, PP_URL_SLUG);
		path = pathParts.join('/');
	}
	return path;
};

const shortenPath = (path: string, options: SimpleRewriteOptions): string => {
	if (!options.keepEnInPath) {
		path = path.replace('/content/fshr/pages/en', '').replace('/content/fourseasons/en', '');
	}
	path = path.replace('/content/fshr/pages', '').replace('/properties/', '/');
	path = path.replace('/content/fourseasons', ''); // ZH is in 2.0
	return path.endsWith('/') ? path : path + '/';
};

const simpleRewrite = (path: string, options: SimpleRewriteOptions = {}) => {
	path = applyPreferredPartnerSlug(path, options);

	if (isAuthorMode(options)) {
		return path;
	}

	return shortenPath(path, options);
};

export default simpleRewrite;
